import { render } from "./TabLayoutPanel.vue?vue&type=template&id=28510b95&scoped=true"
import script from "./TabLayoutPanel.vue?vue&type=script&lang=js"
export * from "./TabLayoutPanel.vue?vue&type=script&lang=js"

import "./TabLayoutPanel.vue?vue&type=style&index=0&id=28510b95&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28510b95"]])

export default __exports__